export const MethodsName = {
  UserConnected: 'UserConnected',
  ReceiveUpdates: 'ReceiveUpdates'
};
